import React, { Component } from 'react';

class OrganisationName extends Component {
  render() {
    const dynamicClass = this.props.className ? ` ${this.props.className}` : "";
    let organisationName = localStorage.getItem("organisationName")

    if (organisationName === "undefined") {
      organisationName = ""
    }

    return (
      <h4 className={`organisation-name${dynamicClass}`}>
        {organisationName}
      </h4>
    );
  }
}

export default OrganisationName;
